import { __decorate, __metadata } from "tslib";
import { h, Host } from "@stencil/core";
import { BEM } from "../../utils/bem";
import { Logger } from "../../utils/log";
export class Stack {
    constructor() {
        this.layout = 'horizontal';
        this.align = '';
        this.space = 'normal';
        this.spaceRow = undefined;
        this.spaceColumn = undefined;
        this.px = '';
        this.py = '';
        this.useWrap = false;
        this.fitContent = false;
        this.direction = '';
        this.alignment = '';
    }
    createLogger(log) {
        this.log = log;
    }
    /**
     * RENDER
     * ------------------------------------------------------
     */
    render() {
        const block = BEM.block('stack');
        const direction = !!this.direction;
        const layout = !!this.layout;
        const align = !!this.align;
        const alignment = !!this.alignment;
        const space = !!this.space;
        const spaceRow = !!this.spaceRow;
        const spaceColumn = !!this.spaceColumn;
        const useWrap = !!this.useWrap;
        const fitContent = !!this.fitContent;
        const px = !!this.px;
        const py = !!this.py;
        let layoutValue = this.layout;
        if (direction) {
            layoutValue = this.direction === 'row' ? 'horizontal' : 'vertical';
        }
        let alignValue = this.align.split(' ').join('-');
        if (alignment) {
            alignValue = this.alignment.split(' ').join('-');
        }
        return (h(Host, { key: '2f606803a40ba86f2912c7315055572e1f4f02f4', class: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, block.class()), block.modifier(`use-wrap`).class(useWrap)), block.modifier(`layout-${layoutValue}`).class(layout || direction)), block.modifier(`align-${alignValue}`).class(align || alignment)), block.modifier(`space-${this.space}`).class(space)), block.modifier(`space-row-${this.spaceRow}`).class(spaceRow)), block.modifier(`space-row-${this.spaceColumn}`).class(spaceColumn)), block.modifier(`px-${this.px}`).class(px)), block.modifier(`py-${this.py}`).class(py)), block.modifier(`fit-content`).class(fitContent)) }, h("slot", { key: '07462da3d47f1e3da2d402e3b3f5f943989b98e9' })));
    }
    static get is() { return "bal-stack"; }
    static get originalStyleUrls() {
        return {
            "$": ["./bal-stack.sass"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["bal-stack.css"]
        };
    }
    static get properties() {
        return {
            "layout": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackLayout",
                    "resolved": "\"\" | \"horizontal\" | \"horizontal-reverse\" | \"vertical\" | \"vertical-reverse\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the position of the child elements if they\nare showed verticaly or horizontally. Default is horizontally."
                },
                "getter": false,
                "setter": false,
                "attribute": "layout",
                "reflect": false,
                "defaultValue": "'horizontal'"
            },
            "align": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackAlignment",
                    "resolved": "\"\" | \"bottom center\" | \"bottom end\" | \"bottom start\" | \"center\" | \"end\" | \"start\" | \"top center\" | \"top end\" | \"top start\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the text positioning like center, right or\ndefault to start."
                },
                "getter": false,
                "setter": false,
                "attribute": "align",
                "reflect": false,
                "defaultValue": "''"
            },
            "space": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackSpace",
                    "resolved": "\"\" | \"auto\" | \"large\" | \"medium\" | \"none\" | \"normal\" | \"small\" | \"x-large\" | \"x-small\" | \"xx-large\" | \"xx-small\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the space between the child elements. Default is normal."
                },
                "getter": false,
                "setter": false,
                "attribute": "space",
                "reflect": false,
                "defaultValue": "'normal'"
            },
            "spaceRow": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackSpace",
                    "resolved": "\"\" | \"auto\" | \"large\" | \"medium\" | \"none\" | \"normal\" | \"small\" | \"x-large\" | \"x-small\" | \"xx-large\" | \"xx-small\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Defines the space between the child elements. Default is normal."
                },
                "getter": false,
                "setter": false,
                "attribute": "space-row",
                "reflect": false
            },
            "spaceColumn": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackSpace",
                    "resolved": "\"\" | \"auto\" | \"large\" | \"medium\" | \"none\" | \"normal\" | \"small\" | \"x-large\" | \"x-small\" | \"xx-large\" | \"xx-small\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Defines the space between the child elements. Default is normal."
                },
                "getter": false,
                "setter": false,
                "attribute": "space-column",
                "reflect": false
            },
            "px": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackPadding",
                    "resolved": "\"\" | \"large\" | \"medium\" | \"none\" | \"normal\" | \"small\" | \"x-large\" | \"x-small\" | \"xx-large\" | \"xx-small\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the horizontal padding left and right of the stack element."
                },
                "getter": false,
                "setter": false,
                "attribute": "px",
                "reflect": false,
                "defaultValue": "''"
            },
            "py": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackPadding",
                    "resolved": "\"\" | \"large\" | \"medium\" | \"none\" | \"normal\" | \"small\" | \"x-large\" | \"x-small\" | \"xx-large\" | \"xx-small\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the vertical padding top and bottom of the stack element."
                },
                "getter": false,
                "setter": false,
                "attribute": "py",
                "reflect": false,
                "defaultValue": "''"
            },
            "useWrap": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines if the child elements will wrap to the next line if there\nis not enough space left"
                },
                "getter": false,
                "setter": false,
                "attribute": "use-wrap",
                "reflect": false,
                "defaultValue": "false"
            },
            "fitContent": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the width of the stack to be exactly the with of the content."
                },
                "getter": false,
                "setter": false,
                "attribute": "fit-content",
                "reflect": false,
                "defaultValue": "false"
            },
            "direction": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackDirection",
                    "resolved": "\"\" | \"column\" | \"row\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "internal",
                            "text": "Please use layout instead."
                        }],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "direction",
                "reflect": false,
                "defaultValue": "''"
            },
            "alignment": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStackAlignment",
                    "resolved": "\"\" | \"bottom center\" | \"bottom end\" | \"bottom start\" | \"center\" | \"end\" | \"start\" | \"top center\" | \"top end\" | \"top start\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "internal",
                            "text": "Please use align instead."
                        }],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "alignment",
                "reflect": false,
                "defaultValue": "''"
            }
        };
    }
}
__decorate([
    Logger('bal-stack'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], Stack.prototype, "createLogger", null);
